// components/ClientLayout.tsx  (CLIENT)
'use client'
import { useEffect, useState } from 'react'
import ThemeProvider from '@/components/ThemeProvider'
import AuthProvider from '@/components/AuthProvider'
import SiteNav from '@/components/SiteNav'
import SiteFooter from '@/components/SiteFooter'
import TidioChat from '@/components/TidioChat'


export default function ClientLayout({ children }: { children: React.ReactNode }) {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  if (!mounted) return null   // <-- gate hydration until client is ready

  return (
    <ThemeProvider>
      <AuthProvider>
        <SiteNav />
        <main>{children}</main>
              <TidioChat />

        <SiteFooter />
      </AuthProvider>
    </ThemeProvider>
  )
}
